"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    oppoConfig: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      ruleForm: {
        appId: '',
        appKey: '',
        appSecret: '',
        channelId: ''
      },
      rules: {
        appId: [{
          required: true,
          message: '请输入appId',
          trigger: 'blur'
        }],
        appKey: [{
          required: true,
          message: '请输入appKEY',
          trigger: 'blur'
        }],
        appSecret: [{
          required: true,
          message: '请输入appSECRET',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    oppoConfig: function oppoConfig(val) {
      this.ruleForm = (0, _objectSpread2.default)({}, val);
    }
  },
  created: function created() {},
  methods: {
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _threePartyConfiguration.thirdConfig)({
              type: 1,
              jigangConfig: {
                type: 2,
                oppoConfig: _this.ruleForm
              }
            }).then(function (res) {
              _this.$notify.success({
                title: '温馨提示',
                message: '保存成功！'
              });
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};